module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/smart-245cb1ff94486d04b796a0005fd74476.png";